import { Layout } from 'react-admin';
import { MyAppBar } from './MyAppBar';

export const MyLayout = (props: any) => {
	return (
		<Layout {...props} appBar={MyAppBar} />
	);
	
};